<template>
    <Teleport to="body" v-if="documentReady">
        <div id="pdp_sticky" class="sticky-bar" v-show="props.isVisible">
            <div class="summary-container">
                <div class="summary pdp-sticky-summary">
                    <div class="pdp-sticky-compare" v-if="props.compareCount" @click="emit('openCompare')">
                        <CompareIcon class="pdp-sticky-compare-icon" alt="compare-icon"/>
                        <div class="summary-text">
                            <p class="text-rothcoBlack" style="font-weight: 600">Compare</p>
                            <p class="text-rothcoBlack">{{ props.compareCount }} of 4 Added</p>
                        </div>
                    </div>
                    <div :class="props.compareCount ? `summary-text product-data pdp-sticky-hide-product-name-mobile` : `summary-text product-data`">
                        <p class="title-m">{{ props.productName }}</p>
                        <p v-if="props.discountPrice != props.originalPrice" class="poduct-price">from <span class="discount">{{ formatPriceAsString(props.discountPrice) }}</span> <span v-if="props.discountPrice < props.originalPrice" class="old-price">{{ formatPriceAsString(props.originalPrice) }}</span></p>
                        <p v-else class="poduct-price">from <span class="discount">{{ formatPriceAsString(props.originalPrice) }}</span></p>
                    </div>
                </div>
            </div>
            <div class="summary-container">
                <button @click="emit('selectOptions')" class="primary" aria-label="proceed to Checkout">
                    Select Options
                    <span aria-hidden="true" class="icon">
                        <CarretsBlack alt="arrow right"/>
                    </span>
                </button>
            </div>
        </div>
    </Teleport>
</template>
<script lang="ts" setup>
    import { ref, onMounted } from "vue";
    import { formatPriceAsString } from "@/helpers/composables/usePriceFormatting";
    import CompareIcon from "@icons/iconamoon_compare-light.svg";
    import CarretsBlack from "@icons/carrets-black.svg";
    const emit = defineEmits(['openCompare', 'selectOptions']);
    let props = defineProps({
        productName: {
            type: String,
            default: ''
        },
        originalPrice: {
            type: [String, Number],
            default: 0
        },
        discountPrice: {
            type: [String, Number],
            default: 0
        },
        compareCount: {
            type: Number,
            default: 0
        },
        isVisible: {
            type: Boolean,
            default: true
        }
    });

    const documentReady = ref(false);
    onMounted(() => {
        documentReady.value = !!document.body;
    });
</script>